import script from "./DailyConfirmedOrdersChart.vue?vue&type=script&setup=true&lang=js"
export * from "./DailyConfirmedOrdersChart.vue?vue&type=script&setup=true&lang=js"

import "./DailyConfirmedOrdersChart.vue?vue&type=style&index=0&id=3fbc0010&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3fbc0010"]])

export default __exports__